"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDriveRemoteContent = void 0;
var runnable_1 = require("../../../common/runnable");
var promise_1 = require("../../../utils/promise");
var namesHelper_1 = require("../../namesHelper");
var BaseDriveRemoteContent = /** @class */ (function () {
    function BaseDriveRemoteContent(client, contentName, settings, contentUrlBuilder) {
        if (contentUrlBuilder === void 0) { contentUrlBuilder = null; }
        this.client = client;
        this.contentName = contentName;
        this.settings = settings;
        this.contentUrlBuilder = contentUrlBuilder;
        // Нам нужно уметь готовить данные для отправки быстрее чем идет отправка данных
        // Т.е. при отправке в 4 потока ещё 2 потока будут подготавливать данные для отправки
        // чтобы быстро начать отправку когда станет возможно
        this.chain = new runnable_1.TaskPool(6);
    }
    BaseDriveRemoteContent.prototype.name = function () {
        return this.contentName;
    };
    BaseDriveRemoteContent.prototype.url = function () {
        /** По умолчанию строится ссылка на контент в drive1 */
        if (this.contentUrlBuilder === null) {
            return namesHelper_1.DriveNamesHelper.buildContentUrlByName(this.settings.apiUrl, this.contentName);
        }
        return this.contentUrlBuilder.build(this.settings.apiUrl, this.contentName);
    };
    BaseDriveRemoteContent.prototype.getMetadata = function () {
        return this.client.getContentMeta(this.contentName);
    };
    BaseDriveRemoteContent.prototype.wait = function () {
        return this.chain.run(function () { return Promise.resolve(); });
    };
    BaseDriveRemoteContent.prototype.initPartialWrite = function (name, size, uploadOptions) {
        var _this = this;
        return this.client.initPartialUpload(name, uploadOptions).then(function (x) {
            if (x.Conflict)
                return { conflict: x.Conflict };
            _this.sessionId = x.UploadSessionId;
            _this.size = size;
            return {
                currentOffset: parseInt(x.AlreadyUploadedBytes),
                uploadSessionId: _this.sessionId,
            };
        });
    };
    BaseDriveRemoteContent.prototype.writeAll = function (source, name, options, token, p) {
        var _this = this;
        return (0, promise_1.using)(this._prepareContentForRemote(source, 0), function (content) {
            return _this.client.uploadContent(name, content, options, token, p);
        });
    };
    BaseDriveRemoteContent.prototype.writePart = function (source, sourceOffset, sinkOffset, count, token, p) {
        var _this = this;
        if (!this.sessionId)
            throw ("BaseDriveRemoteContent: if you are uploading content part by part to drive, " +
                "you have to call initPartialWrite first. Cannot proceed with upload if UploadSessionId is undefined.");
        token && token.throwIfCancelled();
        return this.chain.run(function () {
            return (0, promise_1.using)(_this._prepareContentForRemote(source, sourceOffset, count), function (content) {
                var options = {
                    sessionId: _this.sessionId,
                    bytesFrom: sourceOffset,
                    bytesTo: sourceOffset + count,
                    bytesTotal: _this.size,
                };
                return _this.client.uploadContentPart(content, options, token, p);
            });
        });
    };
    BaseDriveRemoteContent.prototype.getContentMetadata = function () {
        return this.client.getContentMeta(this.contentName);
    };
    BaseDriveRemoteContent.prototype.read = function (sink, sourceOffset, sinkOffset, count, token, p) {
        var _this = this;
        return (0, promise_1.using)(this.client.downloadContent(this._transferFromRemoteOptions(sourceOffset, count), token), function (downloadResult) {
            return _this._transferFromRemote(downloadResult, sink, sinkOffset, count, token, p).then(function () { return downloadResult; });
        });
    };
    return BaseDriveRemoteContent;
}());
exports.BaseDriveRemoteContent = BaseDriveRemoteContent;
